module.exports = __webpack_public_path__ + "img/swipe4.a932697c.png";